import * as React from 'react';
import * as moment from 'moment';

import GridDayContent, { GridDayProps } from '../views/grid-day';

interface GridCellExternalProps {
    currentMonth: moment.Moment;
}

type GridCellProps = GridCellExternalProps & GridDayProps;

const ListCell: React.StatelessComponent<GridCellProps> = (props) => {
    return (
        <div className="grid-cell has-events">
            <GridDayContent day={props.day} />
        </div>
    );
}

export default ListCell;


// WEBPACK FOOTER //
// ./app/calendar/components/list-cell.tsx